export const STRINGS = {
  ADD_MEMBERS: 'Add Members',
  ADD_MEMBER: 'Add Member',
  REGISTER_PAYMENT: 'Register Payment',
  ADD_TRAINER: 'Add Trainer',
  ADD_PAYMENT: 'Add Payment',
  ADD_MEMBERSHIP_PLAN: 'Add Membership',
  UPDATE_MEMBER: 'Update Member',
  UPDATE_TRAINER: 'Update Trainer',
  UPDATE_PAYMENT: 'Update Payment',
  UPDATE_MEMBERSHIP_PLAN: 'Update Membership',
  ADD_QUERY: 'Add Query',
  ADD_MESSAGE: 'Send Message',
  GENDER: 'Gender',
  MALE: 'Male',
  FEMALE: 'Female',
  MEMBERSHIP_PLAN: 'Membership Plan',
  YEARLY: 'Yearly',
  HALF_YEARLY: 'Half-Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
  MODE_OF_PAYMENT: 'Mode Of Payment',
  CASH: 'Cash',
  PAYTM: 'Paytm',
  GOOGLE_PAY: 'Google Pay',
  OTHERS: 'Others',
  SEND: 'Send',
  TOTAL_MEMBERS: 'Total Members',
  THIS_MONTH_MEMBERSHIPS: 'This Month Memberships',
  MEMBERSHIPS_EXPIRING: 'Memberships Expiring This Month',
  CHANGE_PASSWORD: 'Change Password',
  OLD_PASSWORD: 'Old Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  UPDATE: 'Update',
  OLD_PASSWORD_REQUIRED: 'Old Password is required',
  EMAIL_REQUIRED: 'Email is required',
  NEW_PASSWORD_REQUIRED: 'New Password is required',
  FULL_NAME_REQUIRED: 'Full Name is required',
  GYM_NAME_REQUIRED: 'Gym Name is required',
  PHONE_NUMBER_REQUIRED: 'Phone Number is required',
  CONFIRM_PASSWORD_REQUIRED: 'Please confirm your new Password',
  PASSWORD_MISMATCH: 'Old password and Confirm Password Mismatch',
  INVALID_PHONE_NUMBER: 'Invalid Phone Number',
  INVALID_EMAIL: 'Please enter a valid Email address',
  SAVE_DETAILS: 'Save details',
  PROFILE_PIC: 'Profile Pic',
  PHONE_NUMBER: 'Phone Number',
  EMAIL_ADDRESS: 'Email Address',
  GYM_NAME: 'Gym name',
  FULL_NAME: 'Full name',
  RESCHEDULE: 'Reschedule',
  COMPLETE: 'Complete',
  LOGOUT: 'Logout',
  NO_NOTIFICATIONS_FOUND: 'No Notifications found.',
  NO_DATA_FOUND: 'No Data found.',
  EDIT_PROFILE: 'Edit Profile',
  DELETE_ADMIN: 'Delete Account',
  ADD_BATCH: 'Add Batch',
  ADD_GYM: 'Add Gym',
  EDIT_GYM: 'Edit Gym',
  UPDATE_BATCH: 'Update Batch',
  ALL_QUERIES: 'All Queries',
  PENDING_PAYMENT: 'Pending Payments',
  TOTAL_FOLLOW_UPS: 'Totol Follow Ups',
  THIS_MONTH_MEMBERSHIP: 'This Month Memberships',
  EXPIRED_MEMBERSHIPS: 'Expired Memberships',
  TOTAL_FOLLOW_UPS: 'Total Follow-ups',
  TOTAL_TRAINER: 'Total Trainer',
  ADD_DIET_PLAN: 'Add Dietplan',
  UPDATE_DIET_PLAN: 'Update Dietplan',
};
